import { useInspectionStore } from '../store';
import { InspectionTemplatesItems } from '../slices/inspectionTemplates';

export interface UseInspectionTemplatesResult {
  inspectionTemplates: InspectionTemplatesItems;
  loading: boolean;
  removeInspectionTemplate: (
    templateId: string,
    projectId: string
  ) => Promise<void>;
}

export function useInspectionTemplates(): UseInspectionTemplatesResult {
  const inspectionTemplates = useInspectionStore.use.inspectionTemplates();
  const loading = useInspectionStore.use.inspectionTemplatesLoading();
  const removeInspectionTemplate =
    useInspectionStore.use.removeInspectionTemplate();

  return {
    inspectionTemplates,
    loading,
    removeInspectionTemplate,
  };
}
